import { Component, OnInit, Input } from '@angular/core';
import { ContentDataByDataviewDTO, Table } from '@tj/tj-dmp-lib-api';
import { FieldService } from '../../../field/field/field.service';
import { TranslateService } from '@ngx-translate/core';

export type SectionType = 'command' | 'campaign' | 'passenger' | 'personal' | 'other';

interface FieldSection {
  id: SectionType;
  legend: string;
  fields: string[];
}


@Component({
    selector: 'dmp-dyn-raw-detail-fields',
    templateUrl: './dyn-raw-detail-fields.component.html',
    styleUrls: ['./dyn-raw-detail-fields.component.scss'],
    standalone: false
})
export class DynRawDetailFieldsComponent implements OnInit {
  @Input() data: ContentDataByDataviewDTO;
  @Input() tables: Table[];
  @Input() dataviewCode: string;
  @Input() highlightedFields: string[];
  @Input() tenant: string;
  @Input() partner: string;
  displaySections: string[]; 
  
  isCommandDataview: boolean = false;
  isPersonalDataview: boolean = false;
  isLeadDataview: boolean = false;

  private allFieldSections: FieldSection[] = [
    { id: "command", legend: "view.details.fields.command", fields: [] },
    { id: "campaign", legend: "view.details.fields.campaign", fields: [] },
    { id: "passenger", legend: "view.details.fields.passengers", fields: [] },
    { id: "personal", legend: "view.details.fields.personal", fields: [] },
    { id: "other", legend: "view.details.fields.other", fields: [] }
  ];

  customerFields = ['personal.civility', 'personal.firstname', 'personal.lastname', 'personal.email'];

  private tableNameMapping = new Map<string, SectionType>([
    ['command', 'command'],
    ['flight', 'command'],
    ['carrental', 'command'],
    ['hotel', 'command'],
    ['parking', 'command'],
    ['campaign', 'campaign'],
    ['passenger', 'passenger'],
    ['personal', 'personal']
  ]);

  constructor(
    protected fieldService: FieldService,
    private translate: TranslateService
  ) { }

  get fieldSections() : FieldSection[] {
    if (!this.displaySections) {
      return [];
    }
    return this.allFieldSections.filter( section =>
      this.displaySections.includes(section.id)
    );
  }

  ngOnInit(): void {
    this.fieldService.data = this.data;
    this.fieldService.tables = this.tables;

    // Même détection que les onglets de la fiche (dyn-raw-detail-display) : la table principale d'abord,
    // le code de la vue ensuite. Sur le code seul, une vue de contacts au code libre perdait ses tags.
    const tableName = (this.fieldService.dataView?.table?.tableName || '').toLowerCase();
    const dataviewCode = (this.dataviewCode || '').toLowerCase();
    this.isCommandDataview = tableName.includes('command') || dataviewCode.includes('command');
    this.isPersonalDataview = tableName.includes('personal') || dataviewCode.includes('personal');
    this.isLeadDataview = dataviewCode.includes('lead');

    this.tableNameMapping.set(`personal_affilie_${this.partner.toLowerCase()}`, 'personal');


    if (this.isCommandDataview) {
      this.displaySections = ['command'];
    } else if (this.isPersonalDataview) {
      this.displaySections = ['personal'];
    }

    const fieldNames = this.extractFieldNames();
    this.categorizeFields(fieldNames);

  }

  // private extractFieldNames(): string[] {
  //   const fieldNames: string[] = [];
  //   this.tables.forEach(table => {
  //     table.fields
  //       .filter(field => field.categoryField !== "TECHNICAL")
  //       .map(field => `${table.code}.${field.code}`)
  //       .filter(field => this.highlightedFields.includes(field))
  //       .forEach(field => fieldNames.push(field));
  //   });
  //   return fieldNames;
  // }

  private extractFieldNames(): string[] {
    return this.tables.reduce((fieldNames: string[], table: Table) => {
      const tableFields = table.fields
        .filter(field => field.categoryField !== "TECHNICAL")
        .map(field => `${table.code}.${field.code}`)
        .filter(fieldName => !(this.highlightedFields.includes(fieldName)));
      return [...fieldNames, ...tableFields];
    }, []);
  }

  private categorizeFields(fieldNames: string[]): void {
    fieldNames.forEach(name => {
      const tableName = name.split(".")[0];
      const sectionType = this.getSectionType(tableName);
      const section = this.allFieldSections.find(s => s.id == sectionType);
      if(section) {
         section.fields.push(name);
      }
     
    });
  }

  private getSectionType(tableName: string): SectionType {
    return this.tableNameMapping.get(tableName) ?? 'other'
  }

  getSubQuery(subQuery: string) {
    return this.data?.dataSubQuery?.[subQuery]?.content;
  }
  
  openCustomerPurchases() {
    const url = this.buildUrl('command', {key:"email", value:this.data.mainData.rows['personal.email']}, 'command');
    window.open(url, '_blank');
  }
  
  openCustomerDetails(){
    const url = this.buildUrl('personal', {key:"email", value:this.data.mainData.rows['personal.email']}, 'personal', true)
    window.open(url, "_blank")
  }

  private buildUrl(groupDataview: string, param:{key:string, value:string}, viewCode:string, detail:boolean = false): string{
    
    return `/h/view/${groupDataview}?${param.key}=${encodeURIComponent(param.value)}&tenant=${this.tenant}&partner=${this.partner}&code=${viewCode}&detail=${detail}`;
  }
}
